import React, { Fragment } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { Box } from '@tmap/mmm-style-guide/src/Box';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { ChevronLeft } from '@tmap/mmm-style-guide/src/Icon';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { IconButton } from '@tmap/mmm-style-guide/src/IconButton';
import { styled } from '@tmap/mmm-style-guide/src/styled';

const BackButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(0.25),
  color: theme.palette.text.primary,
  padding: 0,
}));

const BreadcrumbContainer = styled(Grid)(() => ({
  display: 'flex',
  alignItems: 'center',
  overflowX: 'hidden',
}));

const BreadcrumbElement = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  overflowX: 'hidden',
}));

const ResponsiveBreadcrumbText = styled(Typography, {
  shouldForwardProp: (p) => p !== 'breakpoint',
})(({ theme, breakpoint }) => ({
  [theme.breakpoints.down(breakpoint)]: {
    minWidth: '15px',
    a: {
      display: 'none',
    },
    '&::after': {
      content: '"..."',
    },
  },
}));

const CurrentPageText = styled(Typography)(() => ({
  overflowX: 'hidden',
  textOverflow: 'ellipsis',
}));

function CommunityControls({ breadcrumbs }) {
  const router = useRouter();
  return (
    <BreadcrumbContainer item xs={12}>
      <BackButton
        size='small'
        onClick={() => router.back()}
        aria-label='Return to previous page'
      >
        <ChevronLeft />
      </BackButton>
      {breadcrumbs.map(({ url, text, breakpoint = 'xs' }, i) => (
        (url)
          ? (
            <Fragment key={`breadcrumb-fragment-${i}`}>
              <BreadcrumbElement key={`breadcrumb-${i}`}>
                <ResponsiveBreadcrumbText variant='body2' color='textPrimary' breakpoint={breakpoint}>
                  <Link href={url}>{text}</Link>
                </ResponsiveBreadcrumbText>
              </BreadcrumbElement>
              <BreadcrumbElement key={`separator-${i}`}>
                <Typography variant='body2' color='textPrimary'>/</Typography>
              </BreadcrumbElement>
            </Fragment>
          )
          : (
            <BreadcrumbElement key={`breadcrumb-${i}`}>
              <CurrentPageText variant='body2' color='textPrimary' fontWeight={600}>
                {text}
              </CurrentPageText>
            </BreadcrumbElement>
          )
      ))}
    </BreadcrumbContainer>
  );
}

export default CommunityControls;
